import React, { useRef, useEffect } from "react";
import Blinds from "../../assets/img/advance-algorithm.png";
import Heading from "../../components/common/Typography/Heading";
import ImageWithLongCardsColumn from "../../components/common/Generics/ImageWithLongCardsColumn";
import Paragraph from "../../components/common/Typography/Paragraph";
import SpecialText from "../../components/common/Typography/SpecialText";

const WhyTradesposter = () => {
  const pinRef = useRef(null);

  useEffect(() => {
    let ScrollTrigger;
    let gsap;
    let triggerInstance;
    if (typeof window !== "undefined") {
      import("gsap").then(gsapModule => {
        gsap = gsapModule.default;
        import("gsap/ScrollTrigger").then(triggerModule => {
          ScrollTrigger = triggerModule.ScrollTrigger;
          gsap.registerPlugin(ScrollTrigger);
          // Calculate offset: (window.innerHeight - 510) / 2 + 255
          const imageHeight = 510;
          const offset = ((window.innerHeight - imageHeight) / 2) + (imageHeight / 2);
          triggerInstance = ScrollTrigger.create({
            trigger: pinRef.current,
            start: "top top",
            endTrigger: document.querySelector('.steps-container'),
            end: "bottom center",
            pin: true,
            pinSpacing: true,
            scrub: false,
          });
        });
      });
    }
    return () => {
      if (ScrollTrigger && triggerInstance) {
        triggerInstance.kill();
      } else if (window.ScrollTrigger) {
        window.ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      }
    };
  }, []);

  return (
    <div className="tp-container-main flex flex-col md:flex-row items-start justify-between gap-44 mx-auto min-h-[510px]">
      {/* Left Side */}
      <div className="flex-1 flex flex-col items-start">
        <div className="steps-container space-y-[60vh] mb-8" style={{ paddingTop: 'calc((100vh - 510px) / 2)' }}>
          <div>
            <Paragraph variant={"MainParagraph"}>
              <span className="font-bold">Sign Up & Verify.</span> Create your account and complete verification (mobile, email) to unlock full access.
            </Paragraph>
          </div>
          <div>
            <Paragraph variant={"MainParagraph"}>
              <span className="font-bold">Browse & Connect.</span> Search services using keywords into search bar or click categories to explore all available services in your area niche by using filters. Use "Get in Touch" on business post or profile to ask more questions by sending inbox messages or contact business from their given details by phone, text or email or even their social media accounts or "Request a Quote" to message 5 local businesses in your area. All communication is managed in your Inbox.
            </Paragraph>
          </div>
          <div>
            <Paragraph variant={"MainParagraph"}>
              <span className="font-bold">Confirm Job Details.</span> Discuss the work, set expectations, and lock in the schedule directly with the business.
            </Paragraph>
          </div>
          <div>
            <Paragraph variant={"MainParagraph"}>
              <span className="font-bold">Pay & Review.</span> Pay the business your way - as agreed (bank transfer, cash, etc.). Leave a verified review using their QR code or review link.
            </Paragraph>
          </div>
        </div>
      </div>
      {/* Right Side */}
      <div className="flex-1 w-full flex justify-center items-center mr-[-11%]">
        <div
          ref={pinRef}
          className="w-[906px] h-[100vh] relative flex justify-center items-center"
        >
          <img
            src={require("../../assets/img/about-us.jpg")}
            className="w-[906px] h-[510px] rounded-xl object-cover"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default WhyTradesposter;
